// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TubeOnClearCastBlanksRouteImport } from './routes/tube-on-clear-cast-blanks'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OtherCreationsRouteImport } from './routes/other-creations'
import { Route as LatheTurnedGiftsRouteImport } from './routes/lathe-turned-gifts'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ForditeAndColorwoodRouteImport } from './routes/fordite-and-colorwood'
import { Route as ForPenTurnersRouteImport } from './routes/for-pen-turners'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EmbeddedObjectBlanksRouteImport } from './routes/embedded-object-blanks'
import { Route as DownloadsRouteImport } from './routes/downloads'
import { Route as DesignYourPieceRouteImport } from './routes/design-your-piece'
import { Route as CustomPensRouteImport } from './routes/custom-pens'
import { Route as CornholeBoardsRouteImport } from './routes/cornhole-boards'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CncEngravedRouteImport } from './routes/cnc-engraved'
import { Route as CalComponentsRouteImport } from './routes/cal-components'
import { Route as BottleStopperBlanksRouteImport } from './routes/bottle-stopper-blanks'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreationsSlugRouteImport } from './routes/creations.$slug'

const TubeOnClearCastBlanksRoute = TubeOnClearCastBlanksRouteImport.update({
            id: '/tube-on-clear-cast-blanks',path: '/tube-on-clear-cast-blanks',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OtherCreationsRoute = OtherCreationsRouteImport.update({
            id: '/other-creations',path: '/other-creations',getParentRoute: () => rootRouteImport
          })
const LatheTurnedGiftsRoute = LatheTurnedGiftsRouteImport.update({
            id: '/lathe-turned-gifts',path: '/lathe-turned-gifts',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const ForditeAndColorwoodRoute = ForditeAndColorwoodRouteImport.update({
            id: '/fordite-and-colorwood',path: '/fordite-and-colorwood',getParentRoute: () => rootRouteImport
          })
const ForPenTurnersRoute = ForPenTurnersRouteImport.update({
            id: '/for-pen-turners',path: '/for-pen-turners',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EmbeddedObjectBlanksRoute = EmbeddedObjectBlanksRouteImport.update({
            id: '/embedded-object-blanks',path: '/embedded-object-blanks',getParentRoute: () => rootRouteImport
          })
const DownloadsRoute = DownloadsRouteImport.update({
            id: '/downloads',path: '/downloads',getParentRoute: () => rootRouteImport
          })
const DesignYourPieceRoute = DesignYourPieceRouteImport.update({
            id: '/design-your-piece',path: '/design-your-piece',getParentRoute: () => rootRouteImport
          })
const CustomPensRoute = CustomPensRouteImport.update({
            id: '/custom-pens',path: '/custom-pens',getParentRoute: () => rootRouteImport
          })
const CornholeBoardsRoute = CornholeBoardsRouteImport.update({
            id: '/cornhole-boards',path: '/cornhole-boards',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CncEngravedRoute = CncEngravedRouteImport.update({
            id: '/cnc-engraved',path: '/cnc-engraved',getParentRoute: () => rootRouteImport
          })
const CalComponentsRoute = CalComponentsRouteImport.update({
            id: '/cal-components',path: '/cal-components',getParentRoute: () => rootRouteImport
          })
const BottleStopperBlanksRoute = BottleStopperBlanksRouteImport.update({
            id: '/bottle-stopper-blanks',path: '/bottle-stopper-blanks',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CreationsSlugRoute = CreationsSlugRouteImport.update({
            id: '/creations/$slug',path: '/creations/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,BottleStopperBlanksRoute: BottleStopperBlanksRoute,CalComponentsRoute: CalComponentsRoute,CncEngravedRoute: CncEngravedRoute,ContactRoute: ContactRoute,CornholeBoardsRoute: CornholeBoardsRoute,CustomPensRoute: CustomPensRoute,DesignYourPieceRoute: DesignYourPieceRoute,DownloadsRoute: DownloadsRoute,EmbeddedObjectBlanksRoute: EmbeddedObjectBlanksRoute,FaqRoute: FaqRoute,ForPenTurnersRoute: ForPenTurnersRoute,ForditeAndColorwoodRoute: ForditeAndColorwoodRoute,GalleryRoute: GalleryRoute,LatheTurnedGiftsRoute: LatheTurnedGiftsRoute,OtherCreationsRoute: OtherCreationsRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,TubeOnClearCastBlanksRoute: TubeOnClearCastBlanksRoute,CreationsSlugRoute: CreationsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)